// Google Ads Conversion Tracking Utilities

/**
 * Track a sign-up conversion event
 * Call this function when a user successfully signs up
 */
export const trackSignUpConversion = () => {
  // Check if gtag is available
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-946941823/gQhtCJO_rpYbEP_exMMD'
      });
      console.log('Google Ads sign-up conversion tracked successfully');
    } catch (error) {
      console.error('Error tracking Google Ads conversion:', error);
    }
  } else {
    console.warn('Google Tag Manager not available for conversion tracking');
  }
};

/**
 * Generic conversion tracking function
 * @param {string} conversionId - The conversion ID from Google Ads
 */
export const trackConversion = (conversionId) => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', 'conversion', {
        'send_to': conversionId
      });
      console.log(`Google Ads conversion tracked: ${conversionId}`);
    } catch (error) {
      console.error('Error tracking Google Ads conversion:', error);
    }
  }
};

/**
 * Track when users click on "Get Started" buttons
 * This provides additional conversion data to Google Ads
 */
export const trackGetStartedClick = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', 'click', {
        'event_category': 'engagement',
        'event_label': 'get_started_button'
      });
      console.log('Get Started button click tracked');
    } catch (error) {
      console.error('Error tracking Get Started click:', error);
    }
  }
};

/**
 * Track form submissions that might lead to conversions
 */
export const trackFormSubmission = (formType = 'contact') => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      window.gtag('event', 'form_submit', {
        'event_category': 'engagement',
        'event_label': formType
      });
      console.log(`Form submission tracked: ${formType}`);
    } catch (error) {
      console.error('Error tracking form submission:', error);
    }
  }
};